import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// export interface VehiclesState {}

const initialState: any = {
  offers: [],
};

export const ormOffersSlice = createSlice({
  name: "ormoffers",
  initialState,
  reducers: {
    setOffers: (state, action: PayloadAction<any[]>) => {
      state.offers = action.payload;
    },
  },
});

export const { setOffers } = ormOffersSlice.actions;

export default ormOffersSlice.reducer;
